import 'css-chunksrc/client/common/scenePlaceholder/styles.scss';export default {
  "scenePlaceholder": "_scenePlaceholder_1jljp_1",
  "icon": "_icon_1jljp_10",
  "group": "_group_1jljp_14",
  "title": "_title_1jljp_21",
  "message": "_message_1jljp_27",
  "button": "_button_1jljp_33"
};